import {Trans} from "@lingui/react/macro";
import {useState} from "react";
import type {Location} from "react-router";
import {Navigate, useLocation, useNavigate} from "react-router";
import * as v from "valibot";
import {TextField} from "../../features/form/fields";
import {useForm} from "../../features/form/Form";
import createId, {IdType} from "../../models/create-id";
import type {UserRepo} from "../../models/UserRepo";
import AppShell from "../../shared/ui/AppShell";
import {Col, css, Text} from "../../ui/Box";
import Button from "../../ui/Button";

const ManualLink = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const {Form, field} = useForm({
    initial: {code: ""},
    schema: v.object({
      code: v.pipe(v.string(), v.nonEmpty()),
    }),
    onSubmit: ({code}) => {
      const lastSlash = code.lastIndexOf("/");
      const secret = code.slice(lastSlash + 1);
      navigate(`/sync/${secret}`);
    },
  });

  return (
    <Col sp="8">
      <Button variant="tertiary" onClick={() => setShow((v) => !v)}>
        <Trans>Manually enter code</Trans>
      </Button>
      {show && (
        <Form className={css({display: "flex", sp: "8"})}>
          <TextField field={field("code")} label={null} />
        </Form>
      )}
    </Col>
  );
};

const Welcome = ({userRepo}: {userRepo: UserRepo}) => {
  const {id} = userRepo.vals.useValues();
  const location = useLocation() as Location<{next: string} | undefined>;
  if (id) return <Navigate to={location.state?.next || "/"} />;

  const handleCreateAccount = () => {
    userRepo.vals.patch({
      id: createId(IdType.User),
      createdAt: new Date(),
      name: undefined,
      isSyncing: false,
    });
  };

  return (
    <AppShell>
      <Col px="12" sp="24" py="24">
        <Text as="h2">
          <Trans>Welcome</Trans>
        </Text>
        <Col rounded="4" surface pa="16" sp="12" align="center">
          <Text as="h2" size="20">
            <Trans>Create New Account</Trans>
          </Text>
          <Button onClick={handleCreateAccount}>
            <Trans>Create Account</Trans>
          </Button>
        </Col>
        <Col rounded="4" surface pa="16" sp="12" align="center">
          <Text as="h2" size="20">
            <Trans>Already have an account?</Trans>
          </Text>
          <Text>
            <Trans>Open the app on the other device and start the "Add device" flow.</Trans>
          </Text>
          <ManualLink />
        </Col>
      </Col>
    </AppShell>
  );
};

export default Welcome;
